import { useCallback, useState } from 'react';
import { EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { useAuth } from '../../features/auth/useAuth';

export type ReauthApi = {
  reauth: (currentPassword: string) => Promise<void>;
  inProgress: boolean;
};

export function useReauth(): ReauthApi {
  const { currentUser, reclaimSession } = useAuth();
  const [inProgress, setInProgress] = useState(false);

  const reauth = useCallback(
    async (currentPassword: string): Promise<void> => {
      if (!currentUser?.email) throw new Error('Usuário sem email.');
      setInProgress(true);
      try {
        const credential = EmailAuthProvider.credential(currentUser.email, currentPassword);
        await reauthenticateWithCredential(currentUser, credential);
        // P92: o reauth renova o auth_time do token; a vaga precisa acompanhar.
        await reclaimSession();
      } finally {
        setInProgress(false);
      }
    },
    [currentUser, reclaimSession]
  );

  return { reauth, inProgress };
}
